import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import ApplicationApiCallBackActions from '../actions/ApplicationApiCallBackActions.js';
import ClientApiCallbackActions from '../actions/ClientApiCallbackActions.js';
import {ApplicationLinkTypes} from '../constants/SelectCustomerConstants.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import ErrorHandler from '../core/ErrorHandler.js';

let ClientsAPI;

function retrieveClient(oin) {
    const url = APIUrl.BASE_ADVISERS_URL + APIUrl.CLIENTS_RETRIEVE + oin;
    ClientApiCallbackActions.clientRetrieveStarted(oin);
    axios.get(url)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ClientApiCallbackActions.clientRetrieveCompleted(response.data);
        })
        .catch((error) => {
            ClientApiCallbackActions.clientRetrieveFailed(oin);
            throw Error('Client Retrieve', error);
        });
}

function resolveClient() {
    if (window.NOA && window.NOA.userContext) {
        // load existing client
        const userContext = window.NOA.userContext;
        if (!userContext.isExisting) {
            return;
        }

        const clientOin = userContext.isAdviser ? window.NOA.clientOin : (userContext.isInvestor ? userContext.oin : null);
        if (clientOin) {
            ClientsAPI.retrieveClient(clientOin);
            if (userContext.isAdviser) {
                // set application link type to existing listed client
                ClientApiCallbackActions.setApplicationLinkType(ApplicationLinkTypes.EXISTING_LISTED_CLIENT);
            }
        }
    }
}

function getParameter(paramName, paramValue) {
    return paramName + '=' + (paramValue ? encodeURIComponent(paramValue) : '');
}

function searchClient(query) {
    const url = APIUrl.BASE_ADVISERS_URL + APIUrl.CLIENTS_SEARCH + 
        '?' + getParameter('query', query.searchValue) +
        '&' + getParameter('firstName', query.firstName) +
        '&' + getParameter('lastName', query.lastName) +
        '&' + getParameter('dateOfBirth', query.dateOfBirth);

    axios.get(url)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ClientApiCallbackActions.setClientSearchResult(response.data);
        })
        .catch((error) => {
            throw Error('Client Search', error);
        });
}

function getClientAccountDetails(productId, clientOin, forRetrieve) {
    const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.GET_CLIENT_ACCOUNT_DETAILS + clientOin;

    axios.get(url)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ApplicationApiCallBackActions.sendClientAccountDetails(response.data, forRetrieve);
        })
        .catch((error) => {
            ErrorHandler.logError(Error('Client account details', error));
        });
}

function getBankAccountDetails(productId) {
    const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.GET_BANK_ACCOUNT_DETAILS;

    axios.get(url)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ApplicationApiCallBackActions.sendBankAccountDetails(response.data);
        })
        .catch((error) => {
            ErrorHandler.logError(Error('Bank account details', error));
        });
}

function verifyMobileNumber(request) {
    const data = JSON.stringify(request);
    const url = APIUrl.BASE_ADVISERS_URL + APIUrl.VERIFY_MOBILE;
    axios.put(url, data)
        .then(ThrowIfStatusNotOk)
        .then((response) => {
            ClientApiCallbackActions.verifyMobileNumberResult(response.data);
        })
        .catch((error) => {
            //according to the business requirements if there is any technical error in the verification,
            //we should not prevent users from going through digital consent so we should return a successful response
            ClientApiCallbackActions.verifyMobileNumberResult(true)
            ErrorHandler.logError(Error('Verify mobile number', error));
        });
}

ClientsAPI = {
    resolveClient: resolveClient,
    retrieveClient: retrieveClient,
    searchClient: searchClient,
    getBankAccountDetails: getBankAccountDetails,
    getClientAccountDetails: getClientAccountDetails,
    verifyMobileNumber: verifyMobileNumber
};

module.exports = ClientsAPI;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/ClientsAPI.js